export const EMPTY_CALENDAR_OFFS = {
  holidays: [] as Array<{ date?: string }>,
  weekends: [] as number[]
};

export type CalendarListQueryData = {
  gantt_calendar?: Array<{
    calendar_holiday_lists?: Array<{ date?: string }>;
    calendar_shift_mapping?: Array<{
      deleted?: boolean;
      work_day?: number;
    }>;
  }>;
};

export function parseCalendarOffsFromQueryData(
  calHolidayData: CalendarListQueryData | null | undefined
) {
  if (!calHolidayData?.gantt_calendar?.length) {
    return EMPTY_CALENDAR_OFFS;
  }

  const calendar = calHolidayData.gantt_calendar[0];
  const holidays = calendar?.calendar_holiday_lists || [];
  const weekends: number[] = [];
  calendar?.calendar_shift_mapping?.forEach((weekday) => {
    if (weekday?.deleted) {
      weekends.push(weekday.work_day!);
    }
  });

  return { holidays, weekends };
}
